<template>
    <v-app>
        <v-toolbar app class="purple darken-3 white--text">
            <v-toolbar-title class="headline">
                <span class="mr-2">BASIS</span>
                <span class="font-weight-light">Registre horari</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-content>

            <v-layout wrap column>
                <!--<v-flex>
                    <nav class="d-flex text-xs-center">
                        <router-link to="/home">Home</router-link>
                        <router-link to="/form-codi">Form Codi</router-link>
                        <router-link to="/fitxar">Fitxar</router-link>
                    </nav>
                </v-flex>-->
                <v-flex fill-height>
                    <router-view></router-view>
                </v-flex>
            </v-layout>


        </v-content>


    </v-app>
</template>

<script>



    export default {
        name: 'App',
        data () {
            return {
                //
            }
        },
    }
</script>

<style>
    @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css";

    .page{position: absolute;width: 100%;height: 100%;}

</style>
